import React from "react";
import { useDispatch, useSelector } from "react-redux";
import renderOriginDestination from "../renderOriginDestination";
import { deleteStop, updateTrips } from "../../../../Redux/Slices/trips.slice";
import TrashIcon from "../../../../Common/Svgs/TrashIcon";

const Header = ({ data, totalLength, setCargo, setActivity }) => {
  const dispatch = useDispatch();

  const { validationForSteps } = useSelector((state) => state.trips);

  const handleDelete = () => {
    dispatch(deleteStop({ stopId: data.id }));

    dispatch(
      updateTrips({
        key: "validationForSteps",
        value: {
          ...validationForSteps,
          step1: {
            ...validationForSteps.step1,
            location: false,
            activity: [],
          },
        },
      }),
    );

    setActivity({ key: 1 });
    setCargo({ key: 1 });
  };

  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center justify-start gap-x-2">
        <img src="/assets/drag.svg" alt="" />

        <div className="flex items-center justify-center w-4 h-4 font-semibold text-white rounded-full bg-yellow-dark font-aileron text-10">
          {data.id}
        </div>

        {renderOriginDestination(data.id, totalLength)}
      </div>

      {data.id === 1 || data.id === totalLength ? null : (
        <div
          onClick={handleDelete}
          className="flex items-center justify-start cursor-pointer gap-x-2"
        >
          <TrashIcon className="text-alert-red" />

          <p className="text-xs font-medium font-poppins text-alert-red">
            Delete
          </p>
        </div>
      )}
    </div>
  );
};

export default Header;
